import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "footerImages" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "middleTextImg" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "footerImages" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "footerImages2" }
const _hoisted_10 = ["src"]

import { FooterImagesItem, useNavigation } from '@/view/home/supportScript';
import { computed} from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'footerImages',
  props: {
    itemData: {}
  },
  emits: ['openContactPopup'],
  setup(__props: any, { emit: __emit }) {

function resolveText(text: string | Record<string, string>): string {
  if (typeof text === 'string') return text
  const lang = localStorage.getItem('lang') || 'en'
  return text[lang] || text['en'] || ''
}

function resolveImage(item: FooterImagesItem | Record<string, FooterImagesItem>): FooterImagesItem {
  if (!item) return { display: false, url: '', redirectUrl: '' }
  if ('url' in item) return item as FooterImagesItem
  const lang = localStorage.getItem('lang') || 'en'
  const localized = item as Record<string, FooterImagesItem>
  return localized[lang] || localized['en'] || { display: false, url: '', redirectUrl: '' }
}

const { goToPath } = useNavigation()
const emits = __emit
const props = __props
const image1 = computed(() => resolveImage(props.itemData.footerImage1))
const image2 = computed(() => resolveImage(props.itemData.footerImage2))
const image3 = computed(() => resolveImage(props.itemData.footerImage3))
const image4 = computed(() => resolveImage(props.itemData.footerImage4))
const image5 = computed(() => resolveImage(props.itemData.footerImage5))
const footerTextTop = computed(() => resolveText(props.itemData.htmlFooterTextTop?.text || ''))
const openContactPopup = () => {
    emits('openContactPopup')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (image1.value.display)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: image1.value.url,
            alt: "",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(goToPath)(image1.value.redirectUrl)))
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        (image2.value.display)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: image2.value.url,
              alt: "",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(goToPath)(image2.value.redirectUrl)))
            }, null, 8, _hoisted_4))
          : _createCommentVNode("", true),
        (_ctx.itemData?.htmlFooterTextTop?.display)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "middleText",
              innerHTML: footerTextTop.value
            }, null, 8, _hoisted_5))
          : _createCommentVNode("", true)
      ]),
      (image3.value.display)
        ? (_openBlock(), _createElementBlock("img", {
            key: 1,
            src: image3.value.url,
            alt: "",
            onClick: openContactPopup
          }, null, 8, _hoisted_6))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      (image4.value.display)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: image4.value.url,
            alt: "",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(goToPath)(image4.value.redirectUrl)))
          }, null, 8, _hoisted_8))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_9, [
      (image5.value.display)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: image5.value.url,
            alt: "",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(goToPath)(image1.value.redirectUrl)))
          }, null, 8, _hoisted_10))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})